module.exports = __webpack_public_path__ + "static/media/web-reputation-img.3fdad627.png";